<template>
  <div>
    <b-container class="pt-4" style="max-width: 1000px">
      <ngos-search></ngos-search>
      <div class="mt-4">
        <template>
          <ngo-search-card
            class="w-75 mx-auto"
            :ngo="ngo"
            v-for="ngo in ngos"
            :key="ngo.id"
          />
        </template>
        <!-- <h4 class="text-center" style="opacity: 0.8" v-else>
          لا توجد نتائج مطابقة للبحث .
        </h4> -->
      </div>
    </b-container>
  </div>
</template>

<script>
import NgosSearch from "../../components/NgosSearch";
import { BContainer, BCard } from "bootstrap-vue";
import { mapGetters } from "vuex";
import NgoSearchCard from "../../components/NgoSearchCard.vue";
export default {
  components: {
    NgosSearch,
    BContainer,
    BCard,
    NgoSearchCard,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("Ministry/NgosSearch", ["ngos", "loading"]),
  },
};
</script>
